import React from 'react';
import MemberSider from './MemberSider';
import ENV from '../../common/env.js';
import UserSider from '../user/UserSider';

class Iframe extends React.Component {
  render() {
    return (
      <div>
        <iframe src={this.props.src} height={this.props.height} width={this.props.width} frameBorder={0} />
      </div>
    )
  }
};

class Distribution extends React.Component {
  state = {
    loading: false,
    dataList: [],
  }

  render() {
    const srcUrl = `${ENV.MAP_URL}/lib/map.html`;
    return (
      <div className="content">
        {
          this.props.src === "UserManage" ?
            <UserSider selectKey='userDistribution' openKeys={['sub1']}/>
            :
            <MemberSider selectKey='memberRequire'/>
        }
        <div className="main map-iframe">
          <Iframe src={srcUrl} height="700" width="1600" />
        </div>
      </div>
    );
  }
}

export default Distribution;



// WEBPACK FOOTER //
// ./src/components/member/Distribution.js